/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : CartListComponent.tsx
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali - H175591
 *
 * @Date         : Oct 03, 2019
 *
 * @Version      : Version 1.0
 *
 * By            	: Madhu Gali (H175591)
 * On            	: Oct 03, 2019
 * Description      : ASDS-1476
 *
 * By            : H224423
 * On            : Oct 10, 2019
 * Description   : ASDS-1478 - Grid level resposnive changes and UI issue fixes
 *
 * By            : Madhu Gali - H175591
 * On            : 18 Oct 2019
 * Description   : ASDS-1549
 *
 * By            : H224423
 * On            : Oct 21, 2019
 * Description   : ASDS-1548 changes.
 *
 * By            : E844276
 * On            : Oct 22, 2019
 * Description   : ASDS-115 changes.
 *
 * By            : E844276
 * On            : Oct 31, 2019
 * Description   : ASDS-408 changes.
 *
 * By            : H224423
 * On            : NOV 11, 2019
 * Description   : Amount field size changes.
 *
 * By            : E844276
 * On            : Nov 13, 2019
 * Description   : ASDS-1808 changes.
 *
 * By            : Suresh Jaladi (E807958)
 * On            : 3 Dec 2019
 * Description   : ASDS-1958
 *
 * By            : H224423
 * On            : Dec 17 2019
 * Description   : UT Automation , Added interfaces
 *
 * By            : H224423
 * On            : Feb 26, 2019
 * Description   : ASDS-2349 - APU Product Features API Integration changes - verbiage changes
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H422335
 * On            : Sep 07 2020
 * Description   : ASDS-2743 - Review Order UI Enhancements as part of APU Phase 2.
 *
 * By            : H422336
 * On            : Oct 9, 2020
 * Description   : ASDS - 3259 UI Enhancements for Phase - II
 *
 * By            : H422337
 * On            : Oct 13, 2020
 * Description   : ASDS-3564 UI Enhancements for phase-2
 *
 * By            : H422337
 * On            : Oct 13, 2020
 * Description   : ASDS-3562 UI Enhancements for phase-2
 *
 * By            : H422337
 * On            : Oct 15, 2020
 * Description   : ASDS-3558 UI Enhancements for phase-2
 *
 * By            : H422337
 * On            : Oct 27, 2020
 * Description   : ASDS-3552 - UI Enhancements for Phase - II Forge API changes
 *
 * By            : H422337
 * On            : Oct 29, 2020
 * Description   : ASDS-3887,ASDS-3570 - UI Enhancements for Phase - II  with Forge API changes
 *
 ******************************************************************************/
import React, { useEffect } from "react";
import { Grid, Icon, Card, Table } from "@scuf/common";
import GenericLoader from "../Loader/Loader";
import { logInfo } from "../../../utils/console-utility";
import CheckoutConstants from "../constants/checkout-constants";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import CartListActions from "../redux/actions/cart-list-actions";
import ReviewOrderActions from "../redux/actions/review-order-actions";
import CartDetailsActions from "../redux/actions/cart-details-actions";
import ApplyCouponActions from "../redux/actions/apply-coupon-actions";
import CartListModelActions from "../redux/actions/cart-list-model-actions";
import CartListModelbActions from "../redux/actions/cart-list-model-b-actions";

const CartListComponent = (props) => {
  // Apply Coupon Logic Starts here
  const { checkInsideReviewOrder }: any = props;
  const checkInsideReviewOrderData = checkInsideReviewOrder?.data;
  const { data } = props;
  const checkCouponData = data?.data;

  let percentageToPoint = checkCouponData?.discount / 100;

  // Extract remaining quantity from coupon api
  let quantity = checkCouponData?.remainingQuantity;

  const sortedList = props.cartList.sort((a, b) => b.totalPrice - a.totalPrice);

  const processData = (data, quantity) => {
    const discount = percentageToPoint;
    const newData: {
      id: number;
      cartList: any[];
    }[] = [];

    let remainingQuantity = quantity;

    const allSortedList = data
      .flatMap((d) =>
        d.cartList.map((cl) => ({
          id: d.id,
          innercartListItem: {
            ...cl,
          },
          tPrice: d.totalPrice,
        }))
      )
      .sort(
        (a, b) => b.innercartListItem.unitPrice - a.innercartListItem.unitPrice
      )
      .slice(0, remainingQuantity);

    allSortedList.forEach((e) => {
      const itemCartToBeUpdate = {
        id: e.id,
        cartList: {
          ...e.innercartListItem,
          discountedUnitPrice:
            e.innercartListItem.unitPrice -
            e.innercartListItem.unitPrice * discount,
        },
      };

      newData.push(itemCartToBeUpdate);
    });

    const finalData: any[] = [];
    for (let i = 0; i < data.length; i++) {
      const cloneddata = { ...data[i] };
      const idlist: any[] = newData
        .filter((f) => f.id === cloneddata.id)
        .map((m) => m.cartList);

      const excludedList = cloneddata.cartList.filter(
        (f) => !idlist.map((i) => i.serialNo).includes(f.serialNo)
      );

      if (idlist.length > 0)
        cloneddata.cartList =
          excludedList.length > 0 ? [...idlist, ...excludedList] : [...idlist];

      finalData.push({
        ...cloneddata,
        calculatedTotal: cloneddata.cartList.reduce(
          (acc, cln) => acc + (cln.discountedUnitPrice || cln.unitPrice),
          0
        ),
      });
    }

    return finalData;
  };

  const newCartList = processData(sortedList, quantity);
  const { couponData } = props;

  let isCouponApply = couponData?.isCoupon;

  const sumOfPercent = newCartList.reduce(
    (acc, product) => acc + (product.totalPrice - product.calculatedTotal),
    0
  );


  useEffect(() => {
    props.getDiscountAmount(sumOfPercent);
  }, [sumOfPercent]);

  const calculateCouponPrice = (product) => {
    return (
      <>
        {isCouponApply &&
          product.calculatedTotal !== product.totalPrice &&
          !checkInsideReviewOrderData && (
            <p>${product.calculatedTotal.toFixed(2)}</p>
          )}
        {isCouponApply &&
          product.calculatedTotal !== product.totalPrice &&
          checkInsideReviewOrderData && (
            <span>${product.calculatedTotal.toFixed(2)}</span>
          )}
        
      </>
    );
  };

  // need to work
  const strikedTotalPrice = (product, amountStyle) => {
    return isCouponApply &&
      
      product.calculatedTotal !== product.totalPrice ? (
      !checkInsideReviewOrderData && (
        <>
          <span
            className={amountStyle}
            style={{ textDecoration: "line-through" }}
          >
            ${product.totalPrice.toFixed(2)}
          </span>
        </>
      )
    ) : (
      <>
        <span className={amountStyle}>${product.totalPrice.toFixed(2)}</span>
      </>
    );
  };

  // need to work
  const itemizedPrice = (cartItem) => {
    return isCouponApply ? (
      cartItem?.discountedUnitPrice ? (
        !checkInsideReviewOrderData ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                textDecoration: "line-through",
              }}
            >
              ${cartItem.unitPrice.toFixed(2)}
            </div>
            <div>
              $
              {(
                cartItem.unitPrice -
                percentageToPoint * cartItem.unitPrice
              ).toFixed(2)}
            </div>
          </div>
        ) : (
          <span>
            $
            {(
              cartItem.unitPrice -
              percentageToPoint * cartItem.unitPrice
            ).toFixed(2)}
          </span>
        )
      ) : (
        <span>${cartItem.unitPrice.toFixed(2)}</span>
      )
    ) : (
      <span>${cartItem.unitPrice.toFixed(2)}</span>
    );
  };

  props.modelData(newCartList);

  const handleCoupon = () => {
    if (props?.cartList?.length === 0) {
      props.hasApplied(false);
    }
  };

  // Apply Coupon Logic ends here

  return (
    <React.Fragment>
      {props.isFetching && (
        <GenericLoader
          text="Fetching Cart List"
          className="cart-list-loader"
          loading={true}
          overlayColor="rgb(247, 247, 247)"
        />
      )}

      {newCartList?.map((product) => (
        <React.Fragment key={product.id}>
          <Card className="cardMarginBottom">
            <Card.Content className="cartListContent">
              <Grid.Row>
                <Grid.Column width={1} xsWidth={2}>
                  {product.prodName
                    .toLowerCase()
                    .includes(CheckoutConstants.APU_PRODUCT_NAME) && (
                    <i className={CheckoutConstants.APU_PRODUCT_CLASSNAME}></i>
                  )}

                  {product.prodName
                    .toLowerCase()
                    .includes(CheckoutConstants.ASPIRE_PRODUCT_NAME) && (
                    <i
                      className={CheckoutConstants.ASPIRE_PRODUCT_CLASSNAME}
                    ></i>
                  )}

                  {product.prodName
                    .toLowerCase()
                    .includes(CheckoutConstants.DLMUW_PRODUCT_NAME) && (
                    <i
                      className={CheckoutConstants.DLMUW_PRODUCT_CLASSNAME}
                    ></i>
                  )}

                  {product.prodName
                    .toLowerCase()
                    .includes(
                      CheckoutConstants.ANALYZER_SERVICE_CENTERS_PRODUCT_NAME
                    ) && (
                    <i
                      className={CheckoutConstants.ANALYZER_PRODUCT_CLASSNAME}
                    ></i>
                  )}

                  {product.prodName
                    .toLowerCase()
                    .includes(
                      CheckoutConstants.FAULT_ANALYZER_SERVICES_PRODUCT_NAME
                    ) && (
                    <i
                      className={CheckoutConstants.FAULT_PRODUCT_CLASSNAME}
                    ></i>
                  )}

                  {product.prodName
                    .toLowerCase()
                    .includes(
                      CheckoutConstants.REMOTE_TERMINAL_SERVICES_PRODUCT_NAME
                    ) && (
                    <i
                      className={
                        CheckoutConstants.REMOTE_TERMINAL_PRODUCT_CLASSNAME
                      }
                    ></i>
                  )}
                </Grid.Column>
                {props.page === CheckoutConstants.MYCART_PAGE && (
                  <Grid.Column
                    width={6}
                    lWidth={6}
                    mWidth={5}
                    xsWidth={10}
                    className="cart-gridcol"
                  >
                    <b className="cart-product-name">{product.prodName}</b>
                  </Grid.Column>
                )}
                {props.page === CheckoutConstants.MYCART_PAGE && (
                  <Grid.Column
                    width={2}
                    lWidth={1}
                    mWidth={2}
                    xsWidth={4}
                    className="cart-gridcol"
                  >
                    <p className="smallText">
                      {product.categoryName.toUpperCase() ===
                        CheckoutConstants.ASPIRE_CATEGORY_NAME.toUpperCase() && (
                        <Icon
                          className="icon-hover edit"
                          root="common"
                          name="edit"
                          size="small"
                          onClick={() => {
                            props.showEditModel(product);
                          }}
                        />
                      )}
                      {product.categoryName.toUpperCase() ===
                        CheckoutConstants.APU_CATEGORY_NAME.toUpperCase() && (
                        <Icon
                          className="icon-hover edit"
                          root="common"
                          name="edit"
                          size="small"
                          onClick={() => {
                            props.showEditModelAPU(product);
                          }}
                        />
                      )}
                      {(product.categoryName.toUpperCase() ===
                        CheckoutConstants.DLMUW_CATEGORY_NAME.toUpperCase() ||
                        product.categoryName.toUpperCase() ===
                          CheckoutConstants.OTHERS_CATEGORY_NAME.toUpperCase()) && (
                        <Icon
                          className="icon-hover edit"
                          root="common"
                          name="edit"
                          size="small"
                          onClick={() => {
                            props.showEditModelWireless(product);
                          }}
                        />
                      )}
                      <Icon
                        className="icon-hover delete"
                        root="common"
                        name="delete"
                        size="small"
                        onClick={() => {
                          handleCoupon();
                          props.onClick(product);
                        }}
                      />
                    </p>
                  </Grid.Column>
                )}
                {props.page === CheckoutConstants.REVIEW_ORDER_PAGE && (
                  <Grid.Column width={8} lWidth={7} mWidth={7} xsWidth={10}>
                    <b className="cart-product-name">{product.prodName}</b>
                  </Grid.Column>
                )}
                <Grid.Column
                  className="fullwidthRow"
                  width={2}
                  lWidth={2}
                  mWidth={2}
                  xsWidth={props.page === CheckoutConstants.MYCART_PAGE ? 4 : 9}
                >
                  <div className="pull-right quantities">
                    <p className="quantity">Quantity</p>
                    {product.cartList.length}
                  </div>
                </Grid.Column>
                <Grid.Column
                  className="fullwidthRow"
                  width={1}
                  lWidth={2}
                  mWidth={2}
                  xsWidth={props.page === CheckoutConstants.MYCART_PAGE ? 4 : 3}
                >
                  <div>
                    <p className="amount">Amount</p>

                    {/* Strike price */}
                    {strikedTotalPrice(product, "amount-value")}

                    {/* Apply Coupon */}
                    <p className="amount-value">
                      {calculateCouponPrice(product)}
                    </p>
                  </div>
                </Grid.Column>
              </Grid.Row>
              {product.categoryName.toUpperCase() ===
                CheckoutConstants.ASPIRE_CATEGORY_NAME.toUpperCase() && (
                <Grid.Row>
                  <Grid.Column className="fullwidthRow" width={12}>
                    <Table className="plainTable myCartTable unstackable">
                      <Table.Header>
                        <Table.HeaderCell
                          content="SCM Serial Numbers"
                          textAlign="left"
                        />
                        <Table.HeaderCell
                          content="PART NUMBER - FEATURE NAME"
                          textAlign="left"
                        />
                        <Table.HeaderCell
                          content="Itemized Price"
                          textAlign="left"
                        />
                      </Table.Header>
                      <Table.Body>
                        {product?.cartList?.map((cartItem, index) => (
                          <Table.Row
                            key={
                              index + cartItem.serialNo + cartItem.partNumber
                            }
                          >
                            <Table.Cell textAlign="left">
                              {cartItem.serialNo}
                            </Table.Cell>
                            <Table.Cell textAlign="left">
                              {cartItem.partNumber} ({cartItem.featureName})
                            </Table.Cell>
                            <Table.Cell textAlign="left">
                              ${cartItem.unitPrice.toFixed(2)}
                            </Table.Cell>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                </Grid.Row>
              )}

              {product.categoryName.toUpperCase() ===
                CheckoutConstants.APU_CATEGORY_NAME.toUpperCase() && (
                <Grid.Row>
                  <Grid.Column className="fullwidthRow" width={12}>
                    <Table className="plainTable myCartTable unstackable">
                      <Table.Header>
                        <Table.HeaderCell content="CATEGORY" textAlign="left" />
                        <Table.HeaderCell
                          content="APU MODEL"
                          textAlign="left"
                        />
                        {product.customerType.msa && (
                          <Table.HeaderCell
                            content="CONTRACT NO."
                            textAlign="left"
                          />
                        )}
                        {!product.customerType.msa &&
                          product.customerType.apuNonMsaSerials[0]
                            .subProductDesc ===
                            CheckoutConstants.NON_MSA_SERVICE_ORDER && (
                            <Table.HeaderCell
                              content="SERVICE ORDER NO."
                              textAlign="left"
                            />
                          )}
                        {!product.customerType.msa &&
                          product.customerType.apuNonMsaSerials[0]
                            .subProductDesc ===
                            CheckoutConstants.NON_MSA_PURCHASE_ORDER && (
                            <Table.HeaderCell
                              content="CUSTOMER PO NO."
                              textAlign="left"
                            />
                          )}
                        <Table.HeaderCell
                          content="APU SERIAL NO."
                          textAlign="left"
                        />
                        {!product.customerType.msa &&
                          product.customerType.apuNonMsaSerials[0]
                            .subProductDesc ===
                            CheckoutConstants.NON_MSA_KEY_ONLY_ORDER && (
                            <Table.HeaderCell
                              content="LICENSE PERIOD"
                              textAlign="left"
                            />
                          )}
                        {product.customerType.msa && (
                          <Table.HeaderCell
                            content="KEY EXPIRATION DATE"
                            textAlign="left"
                          />
                        )}
                        <Table.HeaderCell
                          content="ITEMIZED PRICE"
                          textAlign="left"
                        />
                      </Table.Header>
                      <Table.Body>
                        {product.customerType.msa
                          ? product?.cartList?.map((cartItem, index) => (
                              <Table.Row
                                key={cartItem.serialNo + cartItem.aircraftOem}
                              >
                                <Table.Cell textAlign="left">
                                  {index === 0
                                    ? "Covered under MSA contract"
                                    : ""}
                                </Table.Cell>
                                <Table.Cell textAlign="left">
                                  {index === 0 ? cartItem.model : ""}
                                </Table.Cell>
                                <Table.Cell textAlign="left">
                                  {cartItem.distributionNo}
                                </Table.Cell>
                                <Table.Cell textAlign="left">
                                  {cartItem.serialNo}
                                </Table.Cell>
                                <Table.Cell textAlign="left">
                                  {new Date(cartItem.expiryDate).getFullYear() -
                                    new Date().getFullYear() ===
                                  100
                                    ? "100 years"
                                    : cartItem.expiryDate}{" "}
                                </Table.Cell>
                                <Table.Cell textAlign="left">
                                  ${cartItem.unitPrice.toFixed(2)}
                                </Table.Cell>
                              </Table.Row>
                            ))
                          : product?.cartList?.map((cartItem, index) => (
                              <Table.Row
                                key={cartItem.serialNo + cartItem.aircraftOem}
                              >
                                <Table.Cell textAlign="left">
                                  {index === 0
                                    ? "Not Covered under MSA contract"
                                    : ""}
                                </Table.Cell>
                                <Table.Cell textAlign="left">
                                  {index === 0 ? cartItem.model : ""}{" "}
                                </Table.Cell>
                                {cartItem.subProductDesc !==
                                  CheckoutConstants.NON_MSA_KEY_ONLY_ORDER && (
                                  <Table.Cell textAlign="left">
                                    {cartItem.distributionNo}
                                  </Table.Cell>
                                )}
                                <Table.Cell textAlign="left">
                                  {cartItem.serialNo}
                                </Table.Cell>
                                {cartItem.subProductDesc ===
                                  CheckoutConstants.NON_MSA_KEY_ONLY_ORDER && (
                                  <Table.Cell textAlign="left">
                                    {isNaN(cartItem.term)
                                      ? cartItem.term
                                      : `${cartItem.term} years`}
                                  </Table.Cell>
                                )}
                                <Table.Cell textAlign="left">
                                  {}
                                  {itemizedPrice(cartItem)}
                                </Table.Cell>
                              </Table.Row>
                            ))}
                        {/* Apply Coupon */}
                        {/* {!checkInsideReviewOrderData && (
                          <Table.Row>
                            <Table.Cell textAlign="left"></Table.Cell>
                            <Table.Cell textAlign="left"></Table.Cell>
                            <Table.Cell textAlign="left"></Table.Cell>
                            <Table.Cell textAlign="left"></Table.Cell>
                            <Table.Cell textAlign="left">
                              {calculateCouponPrice(product)}
                            </Table.Cell>
                          </Table.Row>
                        )} */}
                      </Table.Body>
                    </Table>
                    {/* Try Here once with grid */}
                  </Grid.Column>
                </Grid.Row>
              )}
              {(product.categoryName.toUpperCase() ===
                CheckoutConstants.DLMUW_CATEGORY_NAME.toUpperCase() ||
                product.categoryName.toUpperCase() ===
                  CheckoutConstants.OTHERS_CATEGORY_NAME.toUpperCase()) && (
                <Grid.Row>
                  <Grid.Column className="fullwidthRow" width={12}>
                    <Table className="plainTable myCartTable unstackable">
                      <Table.Header>
                        <Table.HeaderCell
                          content="AIRCRAFT TYPE"
                          textAlign="left"
                        />
                        <Table.HeaderCell
                          content="AIRCRAFT SERIAL NO."
                          textAlign="left"
                        />
                        <Table.HeaderCell
                          content="AIRCRAFT TAIL NO."
                          textAlign="left"
                        />
                        <Table.HeaderCell
                          content="ITEMIZED PRICE"
                          textAlign="left"
                        />
                      </Table.Header>
                      <Table.Body>
                        {product?.cartList?.map((cartItem) => (
                          <Table.Row
                            key={
                              cartItem.aircraftSerialNum + cartItem.aircraftType
                            }
                          >
                            <Table.Cell textAlign="left">
                              {cartItem.aircraftType}{" "}
                            </Table.Cell>
                            <Table.Cell textAlign="left">
                              {cartItem.aircraftSerialNum}
                            </Table.Cell>
                            <Table.Cell textAlign="left">
                              {cartItem.aircraftTailNo}
                            </Table.Cell>
                            <Table.Cell textAlign="left">
                              ${cartItem.unitPrice.toFixed(2)}
                            </Table.Cell>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                </Grid.Row>
              )}

              <Grid.Row className="totalprice">
                <Grid.Column width={8} sWidth={1} />
                <Grid.Column className="fullwidthRow" width={4} sWidth={11}>
                  <div className="pull-right">
                    <span className="total-price-text">
                      Total Price: &emsp;
                    </span>

                    {/* Strike price */}
                    {strikedTotalPrice(product, "total-price-amount")}

                    {/* Apply Coupons */}
                    <span
                      style={{ textAlign: "end" }}
                      className="total-price-amount"
                    >
                      {calculateCouponPrice(product)}
                    </span>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Card.Content>
          </Card>
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

const mapDispatchToProps = {
  getDiscountAmount: CartListActions.getDiscountAmount,
  // getAbstractCartView: CartDetailsActions.getCartData
  hasApplied: ApplyCouponActions.hasApplied,
  modelData: CartListModelActions.getModelData,
  modelBData: CartListModelbActions.getModelBData,
};

function mapStateToProps(state) {
  const data1 = state.couponApiSummary?.couponApiSummary;
  const data = data1?.data;
  const couponData1 = state.couponSummary?.couponSummary;
  const couponData = couponData1?.couponData;
  const discountAmount1 = state.cartListData?.cartListData;
  const discountAmount = discountAmount1?.discountAmount;
  const checkInsideReviewOrder1 = state.reviewOrderData?.reviewOrderData;
  const checkInsideReviewOrder =
    checkInsideReviewOrder1?.checkInsideReviewOrder;

  return {
    data,
    discountAmount,
    couponData,
    checkInsideReviewOrder,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CartListComponent));
